// 时间范围选择配置
export default {
  data() {
    return {
      rangePickerOptions: {
        disabledDate(date) {
          return parseInt(date.getTime() / 86400000, 10) >= parseInt(new Date().getTime() / 86400000, 10);
        },
      },
      // 过去日期
      beforeRangeDateOptions: {
        disabledDate(date) {
          return parseInt(date.getTime() / 86400000, 10) >= parseInt(new Date().getTime() / 86400000, 10);
        },
      },
      // 未来日期
      afterRangeDateOptions: {
        disabledDate(date) {
          return parseInt(date.getTime() / 86400000, 10) <= parseInt(new Date().getTime() / 86400000, 10);
        },
      },
      // 现在和过去日期
      beforeEqualRangeDateOptions: {
        disabledDate(date) {
          return parseInt(date.getTime() / 86400000, 10) > parseInt(new Date().getTime() / 86400000, 10) - 1;
        },
      },
      // 现在和未来日期
      afterEqualRangeDateOptions: {
        disabledDate(date) {
          return parseInt(date.getTime() / 86400000, 10) < parseInt(new Date().getTime() / 86400000, 10) - 1;
        },
      },
      // 过去小时
      beforeRangeHourOptions: {
        disabledDate(date) {
          return parseInt(date.getTime() / 3600000, 10) >= parseInt(new Date().getTime() / 3600000, 10);
        },
      },
      // 未来小时
      afterRangeHourOptions: {
        disabledDate(date) {
          return parseInt(date.getTime() / 3600000, 10) <= parseInt(new Date().getTime() / 3600000, 10);
        },
      },
      // 现在和过去小时
      beforeEqualRangeHourOptions: {
        disabledDate(date) {
          return parseInt(date.getTime() / 3600000, 10) > parseInt(new Date().getTime() / 3600000, 10);
        },
      },
      // 现在和未来小时
      afterEqualRangeHourOptions: {
        disabledDate(date) {
          return parseInt(date.getTime() / 3600000, 10) < parseInt(new Date().getTime() / 3600000, 10);
        },
      },
      // 过去分钟
      beforeRangeMinuteOptions: {
        disabledDate(date) {
          return parseInt(date.getTime() / 60000, 10) >= parseInt(new Date().getTime() / 60000, 10);
        },
      },
      // 未来分钟
      afterRangeMinuteOptions: {
        disabledDate(date) {
          return parseInt(date.getTime() / 60000, 10) <= parseInt(new Date().getTime() / 60000, 10);
        },
      },
      // 现在和过去分钟
      beforeEqualRangeMinuteOptions: {
        disabledDate(date) {
          return parseInt(date.getTime() / 60000, 10) > parseInt(new Date().getTime() / 60000, 10);
        },
      },
      // 现在和未来分钟
      afterEqualRangeMinuteOptions: {
        disabledDate(date) {
          return parseInt(date.getTime() / 60000, 10) < parseInt(new Date().getTime() / 60000, 10);
        },
      },
    };
  },
};
